import { Box } from '@material-ui/core';
import React from 'react';
import useCompanyBranding from '../../../../utilities/useCompanyBranding';
import useBasicStyles from '../../useBasicStyles';
import SidePanelMenu from './SidePanelMenu';

export type SidePanelMenuProps = {
    open: boolean;
};

export type DrawerHeaderProps = {
    open: boolean;
};

const DrawerHeader = ({ open }: DrawerHeaderProps) => {
    const classes = useBasicStyles();
    const { logoUrl, faviconUrl } = useCompanyBranding();

    return (
        <Box>
            <Box className={classes.logoWrapper}>
                <img alt="logo" className={classes.logo} src={open ? logoUrl : faviconUrl} />
            </Box>
            <SidePanelMenu open={open} />
        </Box>
    );
};

export default DrawerHeader;
